import { render, staticRenderFns } from "./EpubViewer.vue?vue&type=template&id=15383c96&scoped=true&"
import script from "./EpubViewer.vue?vue&type=script&lang=js&"
export * from "./EpubViewer.vue?vue&type=script&lang=js&"
import style0 from "./EpubViewer.vue?vue&type=style&index=0&id=15383c96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15383c96",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VFlex,VLayout})
